import CapsPage from '@/pages/CapsPage/CapsPage';

export default CapsPage;
